// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__ZyGkR","icon":"SortAdornment_icon__aGKRm","up":"SortAdornment_up__1FN8J","down":"SortAdornment_down__12sEN","active":"SortAdornment_active__HJ5iI"};